module.exports = __webpack_public_path__ + "static/media/one-occupant.533d913f.svg";